export default "__VITE_ASSET__6fefe164__"